import React from 'react';

import {MAX_FILE_SIZE, MAX_FILES_COUNT} from './configs';
import {neutral} from '../theme';

/**
 * Titles
 */
export const TITLE_LAYOUT =
  'Herzlich Willkommen auf der EDEKA Bild- und Mediendatenbank';
export const SUBTITLE_LAYOUT =
  'Gib bitte im Suchfeld EDM, GTIN oder Artikelbezeichnung ein und starte die Suche';

/**
 * Messages
 */
export const AUTHENTICATION_ERROR = 'Fehler bei der Authentifizierung';
export const ERROR = 'Es ist ein Fehler aufgetreten';
export const NO_RESULT = 'Es gab leider keine Ergebnisse zu deiner Suchanfrage';
export const FAILED_LOGIN = (
  <span>
    Dein Benutzername oder Passwort ist nicht korrekt. Bei Problemen setze dein{' '}
    <a
      href="/neues-passwort"
      target="_blank"
      rel="noopener noreferrer"
      style={{color: neutral.white, fontWeight: 'bold'}}
    >
      Passwort zurück
    </a>
    .<br />
    Sollten die Probleme weiterhin bestehen, wende dich an den Servicedesk.
  </span>
);
export const TOKEN_EXPIRED =
  'Dein Login-Token ist abgelaufen. Bitte melde dich erneut an';
export const NO_RESULT_STRUCTURE = 'Es wurden keine Unterknoten gefunden';
export const ERROR_STRUCTURE =
  'Beim Laden der Struktur ist ein Fehler aufgetreten';
export const ERROR_DOWNLOAD = 'Beim Download ist ein Fehler aufgetreten';
export const ERROR_FAVORITES =
  'Beim Prüfen auf Favoriten ist ein Fehler aufgetreten';
export const BASKET_CONTAINS_ID = 'Produkt bereits im Warenkorb enthalten';
export const BASKET_CONTAINS_IDS =
  'Alle gewählten Produkte befinden sich bereits im Warenkorb';
export const BASKET_ID_ADDED = 'Produkt erfolgreich dem Warenkorb hinzugefügt';
export const BASKET_IDS_ADDED =
  'Die gewählten Produkte wurden erfolgreich dem Warenkorb hinzugefügt';
export const BASKET_NOT_CONTAINS_ID = 'Produkt nicht im Warenkorb enthalten';
export const BASKET_ID_REMOVED = 'Produkt erfolgreich aus Warenkorb entfernt';
export const BASKET_CLEARED = 'Warenkorb erfolgreich geleert';
export const BASKET_EMPTY = 'Warenkorb ist leer';
export const BASKET_INVALID_PRODUCTS_REMOVED =
  'Ungültige Artikel wurden aus dem Warenkorb entfernt';

export const MISSING_DERIVATES_MESSAGE =
  'Zu {1} Elementen im Warenkorb konnten keine Derivate erzeugt werden, stattdessen wird für diese das Original heruntergeladen. ' +
  'Für weitere Informationen befindet sich im Download die Datei {2}.';
export const NO_RESULT_METADATA =
  'Es wurden keine Metadaten zu dem Asset geladen';
export const REQUEST_CANCELED =
  'Die laufende Abfrage wurde durch den User abgebrochen';
export const PASSWORD_NOT_EQUAL =
  'Die Eingaben des neuen Passwortes sind nicht identisch';
export const PASSWORD_SUCCESS = 'Das Passwort wurde erfolgreich geändert';
export const MISSING_REQUIRED_INPUTS = 'Bitte alle Pflichtfelder ausfüllen';
export const MASS_SEARCH_TOO_MANY_NUMBERS =
  'Die Massensuche kann maximal {} Elemente suchen';
export const SEARCH_TOO_FEW_CHARACTERS =
  'Bei der Suche bitte mindestens {} Zeichen eingeben';
export const SEARCH_VALUE_PROBLEM =
  'Zu viele Werte im Suchstring oder zu viele einzelne Zeichen';
export const DOWNLOAD_ERROR = 'Fehler beim Download';
export const DOWNLOAD_TOO_WAIT = 'Bitte starte den Download später noch einmal';
export const SUCCESS_CLEAR_MEDIAINBOX = 'Der Medieneingang wurde geleert';
export const SUCCESS_CLEAR_FAVORITES = 'Die Lieblingsbilder wurden geleert';
export const SUCCESS_ASSIGN_ASSET = 'Die Zuweisung war erfolgreich';
export const REQUEST_ASSIGN_ASSET = 'Zuweisung wird gestartet';
export const ERROR_ASSIGN_ASSET = 'Die Zuweisung ist fehlgeschlagen';
export const SUCCESS_DELETE_ASSIGNMENT = 'Die Zuordnung wurde gelöscht';
export const ERROR_DELETE_ASSIGNMENT =
  'Das Löschen der Zuordnung ist fehlgeschlagen';
export const INFO_CHANGE_ASSET = 'Die Änderungen wurden gespeichert';
export const ERROR_CHANGE_ASSET =
  'Beim Starten des Änderungsvorgangs ist ein Fehler aufgetreten';
export const UPLOAD_SUCCESS =
  'Upload erfolgreich. Du kannst die Daten im persönlichen Medieneingang finden.';
export const UPLOAD_SUCCESS_INFO = 'Erfolgreich hochgeladen';
export const UPLOAD_FILEUPLOAD_FINISHED =
  'Der Upload ist abgeschlossen. Die Dateien werden auf dem System verarbeitet.';
export const UPLOAD_PARTIAL_SUCCESS =
  'Die ausgewählten Dateien wurden teilweise erfolgreich hochgeladen. Bitte die entsprechenden Fehlermeldungen prüfen.';
export const UPLOAD_BAD_FILES =
  'Die ausgewählten Dateien entsprechen nicht den Richtlinien. Bitte die entsprechenden Fehlermeldungen prüfen.';
export const UPLOAD_ERROR = 'Beim Upload ist ein Fehler aufgetreten';
export const UPLOAD_ABORTED = 'Der Upload wurde abgebrochen';
export const MAX_FILE_SIZE_EXTENDED = `Die Maximale Dateigröße beträgt ${MAX_FILE_SIZE / 1024} GB. Die Datei {} kann daher nicht hochgeladen werden.`;
export const MAX_FILES_COUNT_EXTENDED = `Die Datei {} wurde entfernt, da mehr als ${MAX_FILES_COUNT} Dateien ausgewählt wurden.`;
export const INVALID_GTIN_OR_PIM_NUMBER =
  'GTINs und PIM-Artikelnummern dürfen nur aus Ziffern bestehen und durch Kommas separiert werden.';
export const UPLOAD_EXTENSION_BUTTON_TEXT_OPEN = ' GTIN/EDM hinzufügen';
export const UPLOAD_EXTENSION_BUTTON_TEXT_CLOSED = 'Felder verbergen';
export const SUCCESS_DELETE_ASSET =
  'Das Asset wurde erfolgreich gelöscht. Die Änderungen treten in Kürze ein.';
export const UNABLE_DELETE_ASSET =
  'Dieses Asset kann nicht gelöscht werden, da eine aktive Artikelverknüpfung besteht.';
export const ERROR_DELETE_ASSET = 'Es ist ein Fehler beim Löschen aufgetreten.';
export const SUCCESS_CHANGE = 'Die Änderung wurde erfolgreich verarbeitet.';
export const STRUCTURE_GROUP_EXITS =
  'Eine Strukturgruppe mit dem angegebenen Namen existiert bereits auf derselben Ebene.';
export const STRUCTURE_GROUP_FAVORITE_SUCCESS = 'Favorit hinzugefügt';
export const STRUCTURE_GROUP_UNFAVORITE_SUCCESS = 'Favorit entfernt';
export const ASSET_FAVORITE_SUCCESS = 'Favorit hinzugefügt.';
export const ASSET_UNFAVORITE_SUCCESS = 'Favorit entfernt.';
export const NO_RESULT_USER_SEARCH =
  'Es wurden keine Benutzer zu der Suche gefunden';
export const NO_PARAMETER_USER_SEARCH =
  'Bitte Benutzergruppe oder Suchtext eingeben';
export const NO_CHANGES = 'Keine Änderungen vorgenommen';
export const USER_CREATED_SUCCESS = 'Der Benutzer wurde erfolgreich erstellt';
export const USER_CREATED_ERROR = 'Fehler beim Erstellen des Benutzers';
export const USER_EDITED_SUCCESS = 'Der Benutzer wurde erfolgreich bearbeitet';
export const USER_EDITED_ERROR = 'Fehler beim Bearbeiten des Benutzers';
export const USER_DELETED_SUCCESS = 'Der Benutzer wurde erfolgreich gelöscht';
export const USER_DELETED_ERROR = 'Fehler beim Löschen des Benutzers';
export const PASSWORD_EXPIRES_SOON =
  'Dein Passwort läuft in {} Tagen ab. Bitte ändere es, um eine Sperre deines Zugangs zu vermeiden.';
export const FORMULAR_ERROR =
  'Beim Absenden des Formulars gab es einen Fehler. Bitte mache hierzu ein Ticket über den EDEKA Servicedesk auf.';
export const USER_UNLOCKED_SUCCESS = 'Der Benutzer wurde erfolgreich {}';
export const PASSWORD_INVALID =
  'Das Passwort erfüllt noch nicht alle Bedingungen.';
export const NEW_USER_LINK_NOT_VALID = 'Link nicht gültig';
export const NEW_USER_REQUEST_LOCKED = 'Der Antrag wurde bereits bearbeitet';
export const NEW_USER_ALREADY_EXITS =
  'Ein User zu der angegebenen Email-Adresse existiert bereits';
export const NEW_USER_MESSAGE = 'Antrag erfolgreich {}';
export const NEW_USER_NO_REQUEST_ID = 'Keine Request ID gefunden';
export const COPY_USERGROUPS_SUCCESS =
  'Die Benutzergruppen wurden erfolgreich kopiert.';
export const USER_SEARCH_ERROR = 'Fehler beim Suchen nach einem Nutzer';
export const ERROR_LOAD_CAPTURE = 'Fehler beim Laden der Captcha-Daten';
export const ERROR_LOAD_ITEMS = 'Fehler beim Laden der Produkte';
export const ERROR_CAPTURE_SOLVING = 'Fehler beim Lösen des Captchas';
export const PASSWORD_RESET_MAIL_SENT =
  'Die Passwort-Mail wurde erfolgreich verschickt';
export const IMAGE_EDITOR_CONTAINS_IDS =
  'Alle gewählten Assets befinden sich bereits in der Bildbearbeitung';
export const IMAGE_EDITOR_NOT_IMAGES =
  'Alle gewählten Assets sind keine Bilder';
export const IMAGE_EDITOR_NOT_AN_IMAGE = 'Das Asset ist kein Bild';
export const IMAGE_EDITOR_IDS_ADDED =
  'Die ausgewählten Assets wurden erfolgreich zur Bildbearbeitung hinzugefügt';
export const IMAGE_QUERY_INVALID_INPUT =
  'Es ist ein Fehler aufgetreten. Bitte überprüfe deine Anfrage oder erstelle ein Ticket über den EDEKA Servicedesk.';
export const IMAGE_QUERY_ACCESS_DENIED =
  'Du hast keine Berechtigung für diese Aktion';
export const IMAGE_QUERY_NOT_FOUND =
  'Die angefragte Bildbearbeitung wurde nicht gefunden';
export const IMAGE_QUERY_INVALID_FORM =
  'Die Bildbearbeitung ist nicht valide und kann nicht gespeichert werden';
export const ERROR_LOAD_IMAGE_QUERIES =
  'Deine gespeicherten Bildbearbeitungen konnten nicht geladen werden';
export const ERROR_LOAD_IMAGE_QUERY =
  'Deine Bildbearbeitung konnte nicht geladen werden';
export const IMAGE_QUERY_CREATE_SUCCESS =
  'Die Bildbearbeitung wurde erfolgreich gespeichert';
export const UNSAVED_CHANGES_CONFIRM =
  'Du hast ungespeicherte Änderungen. Möchtest du die Seite wirklich verlassen?';
